export default __webpack_public_path__ + "static/0307-c3d327e91218a89f6a75681a1cd869de.png";